export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  publishDate: string;
  readTime: string;
  imageSeq: string;
  imageWidth: number;
  imageHeight: number;
  imageQuery: string;
  tags: string[];
  featured: boolean;
}

export const articleCategories = [
  { name: '全部文章', slug: 'all' },
  { name: '广告投放', slug: 'advertising' },
  { name: '数据分析', slug: 'analytics' },
  { name: '创意素材', slug: 'creative' },
  { name: '市场洞察', slug: 'market-insight' },
  { name: '成功案例', slug: 'case-study' },
];

export const articles: Article[] = [
  {
    slug: 'tiktok-game-ad-optimization-2026',
    title: '2026年TikTok游戏广告投放优化指南：从0到1搭建高效买量体系',
    excerpt: '深入解析TikTok广告平台最新算法变化，分享游戏出海企业在TikTok上实现低成本高转化的投放策略与实战技巧。',
    content: `<h2>TikTok游戏广告的崛起</h2>
<p>2026年，TikTok全球月活用户突破25亿，成为游戏出海企业不可忽视的广告投放渠道。相比传统平台，TikTok的短视频形式和算法推荐机制为游戏广告带来了全新的可能性。</p>

<h2>核心投放策略</h2>
<h3>1. 素材创意本地化</h3>
<p>不同市场的用户偏好差异巨大。东南亚用户偏爱真人实拍和剧情向内容，欧美用户更接受游戏画面剪辑和特效展示，日本用户则对二次元风格情有独钟。木瓜玩的创意团队为每个目标市场定制素材方向，平均提升了35%的点击率。</p>

<h3>2. Spark Ads vs Non-Spark Ads</h3>
<p>Spark Ads（达人原生广告）的互动率通常比Non-Spark Ads高出50%以上。我们建议初期预算的40%用于Spark Ads测试，快速找到高效达人合作模式。</p>

<h3>3. 出价策略演进</h3>
<p>从传统的CPM出价转向oCPM（优化千次展示成本），再到最新的Target ROAS出价。木瓜玩的自研出价引擎能够在不同出价策略间动态切换，确保每次投放都获得最优ROI。</p>

<h2>效果衡量与归因</h2>
<p>TikTok广告的归因窗口期设置至关重要。木瓜玩建议将归因窗口设置为7天点击+1天展示，既能准确衡量广告效果，又不会过度归因。配合MMP（移动归因合作伙伴）数据，实现全链路效果追踪。</p>

<h2>总结</h2>
<p>TikTok游戏广告投放需要创意、数据、技术三位一体。木瓜玩提供从素材制作到投放优化的全链路服务，帮助游戏出海企业在TikTok平台实现高效增长。</p>`,
    category: '广告投放',
    categorySlug: 'advertising',
    author: '陈思远',
    publishDate: '2026-07-15',
    readTime: '8分钟',
    imageSeq: 'article-tiktok-2026',
    imageWidth: 800,
    imageHeight: 450,
    imageQuery: 'Modern%20mobile%20phone%20displaying%20colorful%20casual%20mobile%20game%20with%20TikTok%20style%20creative%20video%20ads%20floating%20around%2C%20tech%20marketing%20office%20background%20with%20warm%20ambient%20lighting%2C%20editorial%20photography%20style%2C%20clean%20composition%2C%20soft%20shadows%2C%20professional%20product%20shot',
    tags: ['TikTok广告', '游戏买量', '投放优化', '出海营销'],
    featured: true,
  },
  {
    slug: 'game-ua-data-attribution-2026',
    title: '游戏出海数据归因全解析：如何建立科学的投放效果评估体系',
    excerpt: '探讨游戏出海广告投放中的数据归因方法论，从Last Click到Multi-Touch Attribution，帮助出海团队建立准确的投放效果评估体系。',
    content: `<h2>数据归因为什么是游戏出海的必修课</h2>
<p>在游戏出海的广告投放中，一个用户可能在Facebook看到广告后点击，又在Google搜索游戏名称，最后通过TikTok的达人推荐下载了游戏。那么这次转化应该归功于哪个渠道？这就是数据归因要回答的核心问题。</p>

<h2>主流归因模型对比</h2>
<h3>Last Click（最后点击归因）</h3>
<p>将转化100%归因于用户最后一次点击的渠道。简单易懂但忽略前置触点的贡献，容易导致品牌广告预算被低估。</p>

<h3>Multi-Touch Attribution（多点归因）</h3>
<p>木瓜玩推荐使用MTA模型，将转化价值按权重分配给用户旅程中的每个触点。常见的权重分配方式包括时间衰减、线性分配和基于位置的U型分配。</p>

<h3>数据驱动归因</h3>
<p>基于机器学习算法的归因模型，自动计算每个渠道对转化的实际贡献度。木瓜玩的自研归因引擎采用Shapley值算法，确保归因结果公平且科学。</p>

<h2>实践建议</h2>
<p>1. 务必部署MMP SDK（如AppsFlyer、Adjust），获取第三方归因数据作为基准。</p>
<p>2. 建立渠道级、Campaign级、创意级三层数据看板。</p>
<p>3. 每周进行归因数据复盘，动态调整预算分配。</p>

<h2>木瓜玩的归因解决方案</h2>
<p>木瓜玩提供从SDK部署、数据清洗、归因建模到BI看板搭建的全流程服务，帮助客户建立科学的数据驱动决策体系。</p>`,
    category: '数据分析',
    categorySlug: 'analytics',
    author: '刘静',
    publishDate: '2026-06-28',
    readTime: '10分钟',
    imageSeq: 'article-data-attribution',
    imageWidth: 800,
    imageHeight: 450,
    imageQuery: 'Abstract%20data%20analytics%20dashboard%20with%20colorful%20charts%20and%20graphs%20showing%20marketing%20attribution%20models%2C%20modern%20minimalist%20office%20workspace%20with%20multiple%20monitors%2C%20warm%20amber%20accent%20lighting%2C%20professional%20tech%20environment%2C%20clean%20and%20bright%20composition',
    tags: ['数据归因', 'MMP', '投放分析', 'ROI优化'],
    featured: true,
  },
  {
    slug: 'playable-ads-design-trends-2026',
    title: '2026可玩广告设计趋势：如何制作转化率翻倍的互动素材',
    excerpt: '盘点2026年全球游戏市场中可玩广告的最新设计趋势，分享高效可玩广告的设计原则与A/B测试方法论。',
    content: `<h2>可玩广告的进化</h2>
<p>可玩广告（Playable Ads）已经从简单的"试玩"演变为集品牌展示、玩法体验、转化引导于一体的综合性广告形式。2026年，可玩广告在游戏买量中的占比已超过35%。</p>

<h2>2026年四大设计趋势</h2>
<h3>1. 微交互体验</h3>
<p>不再是简单的截取游戏片段，而是专门为广告设计的15-30秒微交互体验。木瓜玩创意团队发现，独立设计的广告互动体验比游戏片段截取的平均转化率高62%。</p>

<h3>2. AI个性化</h3>
<p>基于用户画像动态调整可玩广告的难度、风格和引导语。休闲玩家看到简单关卡，硬核玩家看到挑战内容，转化率提升明显。</p>

<h3>3. 社交元素嵌入</h3>
<p>在可玩广告中融入排行榜、好友挑战等社交元素，利用用户的竞争心理提升互动率。</p>

<h3>4. 竖屏优先</h3>
<p>随着TikTok和Reels的流行，竖屏可玩广告已成标配。木瓜玩的设计规范已全面转向竖屏优先，适配主流社媒平台。</p>

<h2>A/B测试黄金法则</h2>
<p>木瓜玩为每个可玩广告项目设置至少3组A/B测试：交互方式（点击vs滑动）、难度曲线、结尾CTA设计。通过数据驱动的迭代优化，平均提升45%的转化率。</p>`,
    category: '创意素材',
    categorySlug: 'creative',
    author: '赵雪',
    publishDate: '2026-06-10',
    readTime: '7分钟',
    imageSeq: 'article-playable-ads',
    imageWidth: 800,
    imageHeight: 450,
    imageQuery: 'Creative%20mobile%20game%20playable%20ad%20design%20concept%20with%20interactive%20game%20elements%20floating%20on%20smartphone%20screen%2C%20colorful%20casual%20game%20art%20style%2C%20modern%20creative%20studio%20background%20with%20warm%20lighting%2C%20professional%20product%20photography',
    tags: ['可玩广告', '互动素材', '创意设计', 'A/B测试'],
    featured: false,
  },
  {
    slug: 'southeast-asia-game-market-2026',
    title: '东南亚游戏市场2026深度洞察：RPG与休闲游戏的黄金赛道',
    excerpt: '基于木瓜玩平台数据与第三方调研，全面解析东南亚六大市场游戏用户偏好、付费习惯与增长机会。',
    content: `<h2>东南亚：全球增速最快的游戏市场</h2>
<p>2026年东南亚游戏市场规模突破80亿美元，年增长率保持在12%以上。印尼、泰国、越南三国贡献了超过60%的市场份额。</p>

<h2>各国市场特点</h2>
<h3>印尼 - 人口红利驱动</h3>
<p>2.8亿人口中游戏玩家超过1.5亿。MOBA和吃鸡类游戏占据主导，但休闲游戏增速最快。付费意愿逐步提升，中位ARPPU已达$15。</p>

<h3>泰国 - 高付费意愿市场</h3>
<p>泰国玩家ARPPU在东南亚最高，RPG和策略游戏表现优异。本土化运营至关重要，泰语翻译质量直接影响留存率。</p>

<h3>越南 - 快速增长的移动游戏市场</h3>
<p>越南游戏玩家超过5000万，偏好武侠、三国等东方文化题材。木瓜玩数据显示，越南市场的广告eCPM低于泰国40%，是性价比极高的买量市场。</p>

<h2>品类机会分析</h2>
<p>1. 休闲游戏：三消、跑酷类产品在东南亚仍有巨大增长空间，获客成本仅为欧美市场的1/5。</p>
<p>2. RPG/MMORPG：成熟品类，需要差异化玩法加上强力IP支撑。</p>
<p>3. 社交博弈：在部分法规宽松的国家表现亮眼，但需注意合规风险。</p>

<h2>木瓜玩的东南亚布局</h2>
<p>木瓜玩在新加坡、曼谷、雅加达设有本地化运营团队，提供从市场调研、素材本地化到投放优化的全链路服务。</p>`,
    category: '市场洞察',
    categorySlug: 'market-insight',
    author: '周明',
    publishDate: '2026-05-22',
    readTime: '12分钟',
    imageSeq: 'article-sea-market',
    imageWidth: 800,
    imageHeight: 450,
    imageQuery: 'Southeast%20Asia%20cityscape%20with%20digital%20game%20elements%20overlay%2C%20colorful%20neon%20lights%20reflecting%20modern%20gaming%20culture%2C%20warm%20sunset%20skyline%20of%20Bangkok%20and%20Jakarta%2C%20tech%20style%20illustration%2C%20vibrant%20and%20dynamic%20composition',
    tags: ['东南亚市场', '游戏出海', '市场调研', '本地化'],
    featured: true,
  },
  {
    slug: 'slg-game-global-ua-case-study',
    title: '案例研究：SLG手游全球买量实战，3个月ROI从0.8提升至3.5',
    excerpt: '某知名SLG手游与木瓜玩合作，通过精准投放策略优化与创意素材迭代，在3个月内实现投放ROI的质的飞跃。',
    content: `<h2>项目背景</h2>
<p>客户是一款中世纪题材的SLG手游，上线初期在美国、德国、日本等T1市场进行买量投放。初期面临获客成本高企（CPI $8.5）、ROI仅0.8的困境。</p>

<h2>木瓜玩的解决方案</h2>
<h3>第一步：数据诊断</h3>
<p>木瓜玩数据团队对客户3个月的投放数据进行全面审计，发现三个核心问题：</p>
<p>1. 受众定向过窄，仅覆盖SLG核心用户群体，忽视了泛策略玩家。</p>
<p>2. 素材疲劳严重，同一素材在单个用户面前展示超过5次后，点击率下降70%。</p>
<p>3. 出价策略单一，未利用平台的自动出价能力。</p>

<h3>第二步：策略重构</h3>
<p>1. 扩展受众定向至泛策略游戏玩家、历史题材爱好者、中世纪文化兴趣人群。</p>
<p>2. 建立素材迭代机制，每周更新30%的广告素材，A/B测试至少5组新创意。</p>
<p>3. 混合使用Target CPA和Target ROAS出价策略，根据Campaign阶段动态调整。</p>

<h3>第三步：创意突破</h3>
<p>木瓜玩创意团队发现，中世纪城堡攻防的可玩广告互动率是普通视频广告的2.3倍。团队迅速制作了10组不同难度和场景的可玩广告进行测试。</p>

<h2>成果</h2>
<p>合作3个月后：</p>
<p>- 获客成本（CPI）从$8.5降至$3.2</p>
<p>- 7日留存率从18%提升至31%</p>
<p>- 整体投放ROI从0.8提升至3.5</p>
<p>- 月新增用户从15万增长至60万</p>`,
    category: '成功案例',
    categorySlug: 'case-study',
    author: '陈思远',
    publishDate: '2026-04-18',
    readTime: '9分钟',
    imageSeq: 'article-slg-case',
    imageWidth: 800,
    imageHeight: 450,
    imageQuery: 'Medieval%20strategy%20game%20art%20with%20castle%20siege%20scene%2C%20dramatic%20lighting%20with%20warm%20golden%20accents%2C%20professional%20game%20concept%20art%20style%2C%20dark%20moody%20atmosphere%20with%20fire%20and%20battle%20elements%2C%20epic%20fantasy%20composition',
    tags: ['SLG', '买量案例', 'ROI优化', '可玩广告'],
    featured: true,
  },
  {
    slug: 'google-ads-game-campaign-2026',
    title: 'Google Ads游戏广告Campaign 2026更新：UAC进阶玩法全解读',
    excerpt: 'Google Ads for Games最新功能详解，包括App Campaign 3.0、资产级报告和自动化创意优化。',
    content: `<h2>Google Ads游戏广告的重大更新</h2>
<p>2026年，Google推出了App Campaign 3.0，为游戏广告主带来了更强大的自动化投放能力和更精细的数据报告。</p>

<h2>App Campaign 3.0核心功能</h2>
<h3>资产级报告</h3>
<p>广告主现在可以查看每个素材资产（图片、视频、文案）的独立表现数据，而非仅仅Campaign级别的汇总数据。这意味着可以精确识别高效和低效素材。</p>

<h3>自动化创意优化</h3>
<p>Google AI会自动组合不同的素材资产，生成数千种广告变体进行测试，并自动将预算分配给表现最佳的变体组合。</p>

<h3>多目标优化</h3>
<p>支持同时优化安装量和特定应用内事件（如首日留存、首次付费），实现更高维度的投放目标。</p>

<h2>木瓜玩的UAC优化方法</h2>
<p>1. 每个Campaign提供至少20个素材资产，确保AI有充足的优化空间。</p>
<p>2. 设置tCPI（目标每次安装成本）时需要综合考虑LTV数据，避免出价过低错失高价值用户。</p>
<p>3. 每2周进行素材资产刷新，保持广告新颖度。</p>`,
    category: '广告投放',
    categorySlug: 'advertising',
    author: '林浩',
    publishDate: '2026-03-30',
    readTime: '6分钟',
    imageSeq: 'article-google-ads',
    imageWidth: 800,
    imageHeight: 450,
    imageQuery: 'Google%20Ads%20dashboard%20interface%20on%20modern%20desktop%20monitor%2C%20colorful%20data%20charts%20and%20campaign%20metrics%2C%20warm%20office%20environment%20with%20natural%20light%2C%20professional%20digital%20marketing%20workspace%2C%20clean%20tech%20aesthetic',
    tags: ['Google Ads', 'UAC', 'App Campaign', '投放教程'],
    featured: false,
  },
  {
    slug: 'game-aso-strategy-2026',
    title: '游戏ASO优化全攻略：App Store与Google Play双平台排名提升秘籍',
    excerpt: '系统梳理App Store和Google Play的ASO优化策略，从关键词研究到转化率优化，帮助游戏产品获得更多自然流量。',
    content: `<h2>ASO：被低估的增长杠杆</h2>
<p>在买量成本持续攀升的背景下，ASO（应用商店优化）成为游戏出海最具性价比的增长手段。木瓜玩数据显示，ASO优化后自然量占比可提升15-30%。</p>

<h2>双平台优化策略</h2>
<h3>App Store优化</h3>
<p>1. 关键词：利用Apple Search Ads数据反推高效关键词，每个版本更新时优化关键词字段。</p>
<p>2. 视觉资产：前3张截图决定80%的转化率，优先展示游戏最核心的玩法和亮点。</p>
<p>3. 评分管理：建立评分提醒机制，4星以上用户引导评价，低分用户引导至客服渠道。</p>

<h3>Google Play优化</h3>
<p>1. 长描述中的关键词密度优化，Google Play的索引机制与网页SEO类似。</p>
<p>2. 利用Google Play Experiments进行图标和截图的A/B测试。</p>
<p>3. Android Vitals性能指标直接影响搜索排名，需持续关注崩溃率和ANR率。</p>

<h2>木瓜玩的ASO方法论</h2>
<p>我们提供从关键词研究、竞品分析、元数据优化到素材迭代的全流程ASO服务，通常3个月内可显著提升自然流量。</p>`,
    category: '数据分析',
    categorySlug: 'analytics',
    author: '刘静',
    publishDate: '2026-03-12',
    readTime: '8分钟',
    imageSeq: 'article-aso',
    imageWidth: 800,
    imageHeight: 450,
    imageQuery: 'App%20Store%20and%20Google%20Play%20store%20listings%20displayed%20on%20smartphone%20screens%2C%20colorful%20game%20icons%20and%20screenshots%2C%20modern%20minimalist%20desk%20setup%20with%20warm%20lighting%2C%20professional%20app%20marketing%20concept%2C%20clean%20composition',
    tags: ['ASO优化', '商店优化', '自然流量', 'App Store'],
    featured: false,
  },
  {
    slug: 'game-creative-localization-guide',
    title: '游戏出海素材本地化指南：一个素材如何适配全球30+市场',
    excerpt: '分享游戏广告素材本地化的系统方法论，从文化差异到设计规范，帮助出海团队高效制作多市场适配素材。',
    content: `<h2>本地化≠翻译</h2>
<p>真正的素材本地化远不止语言翻译。它涉及文化符号、色彩偏好、角色形象、UI习惯等多维度的适配。木瓜玩的本地化体系覆盖全球30+市场。</p>

<h2>本地化五大维度</h2>
<h3>1. 语言适配</h3>
<p>不仅是翻译，还需要考虑字体设计、文字排版方向（阿拉伯语RTL）、文案长度（德语通常比英语长30%）。</p>

<h3>2. 文化符号</h3>
<p>西方市场的"OK"手势在巴西具有冒犯性；红色在中国代表喜庆在部分国家代表警告。木瓜玩为每个市场编写了文化禁忌清单。</p>

<h3>3. 角色形象</h3>
<p>不同市场对角色审美偏好差异巨大。日本市场偏好二次元风格，欧美市场偏好写实风格，东南亚市场兼容性较强。</p>

<h3>4. 色彩体系</h3>
<p>绿色在中东具有特殊的宗教意义；白色在亚洲部分市场与丧葬相关。素材配色需要参考目标市场的色彩偏好。</p>

<h3>5. 平台规范</h3>
<p>不同广告平台对素材尺寸、时长、内容限制各不相同。木瓜玩建立了覆盖20+平台的素材规范知识库。</p>

<h2>效率提升工具</h2>
<p>木瓜玩自研的素材本地化平台支持：模板化管理、AI辅助适配、批量渲染输出，将本地化效率提升了300%。</p>`,
    category: '创意素材',
    categorySlug: 'creative',
    author: '赵雪',
    publishDate: '2026-02-25',
    readTime: '7分钟',
    imageSeq: 'article-localization',
    imageWidth: 800,
    imageHeight: 450,
    imageQuery: 'Creative%20game%20advertising%20materials%20in%20multiple%20languages%20and%20cultural%20styles%20displayed%20on%20a%20modern%20designer%20desk%2C%20colorful%20mobile%20game%20art%20variations%2C%20warm%20creative%20studio%20lighting%2C%20professional%20multicultural%20marketing%20concept',
    tags: ['本地化', '素材制作', '文化适配', '出海指南'],
    featured: false,
  },
  {
    slug: 'casual-game-mena-market',
    title: '中东游戏市场掘金：休闲游戏如何在MENA地区实现爆发式增长',
    excerpt: '深入分析中东和北非（MENA）游戏市场的特点与机遇，聚焦休闲游戏赛道的本地化策略与用户获取方法。',
    content: `<h2>MENA：被低估的黄金市场</h2>
<p>MENA（中东和北非）地区拥有超过4亿人口，智能手机普及率超过75%，ARPPU在沙特和阿联酋市场可媲美T1欧美市场。然而由于文化壁垒，许多中国游戏企业尚未充分开发这一市场。</p>

<h2>市场特点</h2>
<h3>高ARPU、高留存</h3>
<p>沙特玩家的平均月消费超过$25，是东南亚市场的5倍以上。且中东玩家对游戏忠诚度极高，头部游戏的月留存率可达40%。</p>

<h3>社交属性强</h3>
<p>中东玩家重视游戏内的社交互动，公会系统和排行榜功能对留存有显著提升作用。语音聊天功能的渗透率远高于全球均值。</p>

<h3>本地化要求极高</h3>
<p>阿拉伯语RTL适配、伊斯兰文化尊重、本地节日活动（如斋月特别活动）是赢得中东市场的必要条件。</p>

<h2>休闲游戏机会</h2>
<p>1. 三消游戏：中东女性玩家偏好度高，且付费意愿强。</p>
<p>2. 纸牌/棋牌：需注意赌博合规，但社交棋牌类表现出色。</p>
<p>3. 超休闲：获客成本低，适合作为流量入口。</p>

<h2>木瓜玩的中东团队</h2>
<p>木瓜玩在迪拜设有区域中心，拥有阿拉伯语母语运营团队，为出海企业提供从市场调研到投放执行的全链路MENA市场服务。</p>`,
    category: '市场洞察',
    categorySlug: 'market-insight',
    author: '周明',
    publishDate: '2026-02-08',
    readTime: '9分钟',
    imageSeq: 'article-mena-market',
    imageWidth: 800,
    imageHeight: 450,
    imageQuery: 'Modern%20Dubai%20skyline%20with%20futuristic%20digital%20game%20elements%20overlay%2C%20warm%20golden%20desert%20sunset%20colors%2C%20luxurious%20Middle%20East%20cityscape%2C%20tech%20and%20gaming%20culture%20fusion%2C%20vibrant%20professional%20illustration',
    tags: ['中东市场', 'MENA', '休闲游戏', '本地化'],
    featured: false,
  },
  {
    slug: 'game-rewarded-video-ads-guide',
    title: '激励视频广告变现全攻略：不破坏体验的游戏内广告设计',
    excerpt: '如何设计既不伤害用户体验又能最大化广告收入的激励视频广告体系？本文给出系统性的设计原则与数据参考。',
    content: `<h2>激励视频广告的黄金时代</h2>
<p>2026年，激励视频广告已成为休闲和超休闲游戏最重要的收入来源之一，占IAA收入的60%以上。但设计不当的广告系统会严重损害用户体验和留存率。</p>

<h2>设计核心原则</h2>
<h3>1. 用户主动触发</h3>
<p>永远不要让广告打断用户的游戏体验。激励视频应该是用户主动选择观看以换取奖励，而非强制展示。</p>

<h3>2. 奖励感知价值</h3>
<p>奖励需要让用户感到"值得"。木瓜玩数据显示，当感知奖励价值>=3分钟游戏收益时，广告参与率最高（约65%）。</p>

<h3>3. 频率控制</h3>
<p>过度曝光会降低广告价值。建议设置每日观看上限（通常8-12次），并在每次观看之间设置冷却时间。</p>

<h3>4. 场景化设计</h3>
<p>将广告入口设计得与游戏场景自然融合。例如在失败后提供"观看广告复活"，在商店中提供"观看广告获得免费金币"。</p>

<h2>数据参考</h2>
<p>- 激励视频eCPM：T1市场$12-18，T2市场$5-8，T3市场$1-3</p>
<p>- 广告渗透率目标：DAU的30-40%</p>
<p>- 理想ARPDAU（广告）：$0.15-0.35（休闲游戏）</p>`,
    category: '数据分析',
    categorySlug: 'analytics',
    author: '林浩',
    publishDate: '2026-01-18',
    readTime: '7分钟',
    imageSeq: 'article-rewarded-video',
    imageWidth: 800,
    imageHeight: 450,
    imageQuery: 'Mobile%20game%20screen%20showing%20rewarded%20video%20ad%20interface%20with%20colorful%20rewards%2C%20casual%20game%20art%20style%2C%20modern%20smartphone%20display%2C%20warm%20and%20inviting%20game%20environment%2C%20clean%20UI%20design%20concept',
    tags: ['激励视频', '广告变现', 'IAA', '用户体验'],
    featured: false,
  },
];